<ng-content data-test-id="paginatorContent"></ng-content>

<div class="paginator-content" data-test-id="paginatorPageCountButtonsWrapper">
  <zip-page-count
    class="page-count"
    data-test-id="paginatorPageCount"
    [firstShowing]="firstShowing"
    [lastShowing]="lastShowing"
    [totalCount]="totalResultCount"
  >
    <ng-content
      data-test-id="paginatorPageCountContent"
      select="[count-row]"
    ></ng-content>
  </zip-page-count>

  @if (totalCount > 1) {
    <zip-page-buttons
      class="page-buttons"
      data-test-id="paginatorButtons"
      [totalCount]="totalCount"
      [currentPage]="currentPage"
      (pageButtonClick)="onPageButtonClick($event)"
    >
    </zip-page-buttons>
  }
</div>
